<template>
  <div class="container">
    <!-- 서브상단영역 -->

    <Banner
      title="etc"
      subtitle="etc"
      description="학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>
        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
    />

    <Navbar />

    <div class="width_wrap">
      <Sidebar />
      <div class="body_content sub">
        <!-- 서브 타이틀영역 -->
        <h1 class="sub_subject">비전과 미션<span></span></h1>
        <!-- //서브 타이틀영역 -->
        <figure>
          <n-space justify="center">
            <img
              src="@/assets/img/vision_mission.png"
              style="width: 800px"
              alt="비전"
            />
          </n-space>
        </figure>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import Navbar from "@/views/etc/Navbar.vue";
import Sidebar from "@/views/etc/page/Sidebar.vue";
import Banner from "@/components/Banner.vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";

const isOpen = ref(false);

// 토글 함수
function toggleRow() {
  isOpen.value = !isOpen.value;
}
</script>

<style scoped>
.scbd .sp-ico {
  background-image: url("@/assets/img_up/shop_pds/kp708b/design/rwdClear/sp-icons@2x.png");
  background-size: 300px 250px;
}

.sub_title_01 p {
  position: absolute;
  top: 70px;
  left: 0;
  margin-top: -15px;
  width: 100%;
  font-size: 30px;
  color: #fff;
  text-align: center;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 600;
}
.sub_title_01 h2 {
  position: absolute;
  top: 130px;
  left: 0;
  margin-top: -15px;
  width: 100%;
  font-size: 19px;
  color: #fff;
  text-align: center;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 500;
  line-height: 1.7em;
}

.box01 {
  position: relative;
  overflow: hidden;
}
.box01 figure {
  margin-bottom: 20px;
  text-align: center;
  width: 170px;
  margin: 0 auto 20px auto;
  display: none;
}
.box01 figure span {
  display: block;
  background: #fff;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  padding: 5px 0 0 0;
}
.sub01_wrap h1 {
  font-size: 17px;
  padding-top: 10px;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 500;
  position: relative;
}
.sub01_wrap h1:after {
  position: absolute;
  content: "";
  left: 0;
  top: 0;
  width: 50px;
  height: 2px;
  background: #00417e;
}
.sub01_wrap h2 {
  font-size: 17px;
  margin-bottom: 15px;
  padding-bottom: 12px;
  border-bottom: 3px solid #00417e;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 500;
}
.sub01_wrap p {
  font-size: 14px;
  margin-bottom: 15px;
  line-height: 1.6em;
  color: #454545;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 400;
  word-break: keep-all;
  text-align: justify;
}
.sub01_wrap h3 {
  font-size: 16px;
  text-align: center;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 500;
  position: relative;
  padding-bottom: 50px;
  text-align: right;
}
.sub01_wrap h3 > span {
  padding-right: 10px;
}
@media screen and (min-width: 768px) {
  .box01 figure {
    margin: 0px auto 20px auto;
  }
  .sub01_wrap h1 {
    font-size: 19px;
  }
  .sub01_wrap h2 {
    font-size: 19px;
  }
  .sub01_wrap p {
    font-size: 16px;
  }
}
@media screen and (min-width: 1100px) {
  .box01 > div {
    border: 1px solid #eaeaea;
    padding: 70px 30px 20px 30px;
    box-sizing: border-box;
  }
  .box01 figure {
    position: absolute;
    top: 45px;
    left: 0;
    width: 120px;
    z-index: 99;
  }
}
</style>
